module.exports = __webpack_public_path__ + "img/5-5.8192b683.svg";